import {useMemo} from "react";
import {CombatantEvent, CombatantTransformBatch} from "@/api/CombatantApi.ts";
import {useRealtimeChannel, useRealtimePublisher} from "@/api/realtime/RealtimeChannelHooks.ts";

export function useCombatantRealtime(encounterId: string) {
    const {subscribe, onConnected} = useRealtimeChannel<CombatantEvent>(`/encounters/${encounterId}/combatants`);
    const publishTransforms = useRealtimePublisher<CombatantTransformBatch>(
        `/encounters/${encounterId}/combatants/transforms/live`,
    );
    return useMemo(() => ({subscribeToUpdates: subscribe, publishTransforms, onConnected}), [publishTransforms, subscribe, onConnected]);
}
